import {
    useTranslate,
    IResourceComponentsProps,
    // CrudFilters,
    HttpError,
} from "@pankod/refine-core";

import {
    List,
    Table,
    // Avatar,
    useTable,
    // DateField,
    BooleanField,
    // Card,
    CreateButton,
    // Input,
    // Icons,
    // Form,
    // DatePicker,
    // Button,
    // Select,
    // FilterDropdown,
    // FormProps,
    // Row,
    // Col,
    // ShowButton,
    EditButton,
    // useSelect,
    useDrawerForm,
} from "@pankod/refine-antd";

import { ICategory } from "../../interfaces";
// import { IProfile, IUserFilterVariables, IOrganization } from "interfaces";

import { CreateCategory, EditCategory } from "components/category";

export const CategoryList: React.FC<IResourceComponentsProps> = () => {
  const { tableProps } = useTable<
    ICategory,
    HttpError
    // IUserFilterVariables
  >({
    resource: "categories",
    initialSorter: [{
      field: "title",
      order: "asc",
    }],
    metaData: {
      select: "*",
      // select: "*, organizations:organization_id(title)",
    },
    syncWithLocation: false,
  });

  const t = useTranslate();

  const {
    drawerProps: createDrawerProps,
    formProps: createFormProps,
    saveButtonProps: createSaveButtonProps,
    show: createShow,
  } = useDrawerForm<ICategory>({
    action: "create",
    resource: "categories",
    redirect: false,
  });

  const {
    drawerProps: editDrawerProps,
    formProps: editFormProps,
    saveButtonProps: editSaveButtonProps,
    show: editShow,
  } = useDrawerForm<ICategory>({
    action: "edit",
    resource: "categories",
    redirect: false,
  });

  // const { selectProps } = useSelect<IOrganization>({
  //   resource: "organizations",
  // });

  return (
    <>
      {/* <Row gutter={[16, 16]}> */}
        {/* <Col xl={18} xs={24}> */}
          <List pageHeaderProps={{ extra: <CreateButton onClick={() => createShow()}> {t("categories.titles.create")}</CreateButton> }}>
            <Table {...tableProps} rowKey="id">
              <Table.Column
                key="title"
                dataIndex="title"
                title={t("categories.fields.title")}
              />
              <Table.Column
                key="isActive"
                dataIndex="isActive"
                title={t("categories.fields.isActive")}
                render={(value) => <BooleanField value={value} />}
              />
              <Table.Column<ICategory>
                title={t("table.actions")}
                render={(_, record) => (
                  <EditButton hideText onClick={() => editShow(record.id)} />
                )}
              />
            </Table>
          </List>
        {/* </Col> */}
      {/* </Row> */}
      <CreateCategory drawerProps={createDrawerProps} formProps={createFormProps} saveButtonProps={createSaveButtonProps} />
      <EditCategory drawerProps={editDrawerProps} formProps={editFormProps} saveButtonProps={editSaveButtonProps} />
    </>
  );
};


